import React, { ReactNode } from 'react';
import { Brand, Content, ContentColumn, Root } from './auth-layout.styles';

export interface AuthLayoutProps {
    /** The brand column: a panel beside the content, a header strip above it. */
    brand?: ReactNode;
    children: ReactNode;
}

/**
 * The page frame the unauthenticated screens share: brand on one side, content
 * on the other, stacking to a single column when two no longer fit.
 *
 * This replaces the library's `SplitScreen` for these screens. That component
 * fixed its columns at 360px and 720px with no media queries, so every page
 * built on it had a hard 936px floor and scrolled sideways on a phone. Where
 * the layout breaks is a product decision that changes with the product, so it
 * belongs here rather than in the design system.
 *
 * It is deliberately scoped to form-width entry screens and takes no layout
 * props. The setup flow and settings also split the screen, but with wider
 * content and a step menu or side nav in the first column; those want their
 * own layouts rather than options on this one.
 */
export const AuthLayout: React.FunctionComponent<AuthLayoutProps> = ({ brand, children }) => (
    <Root>
        {brand && <Brand>{brand}</Brand>}
        <Content>
            <ContentColumn>{children}</ContentColumn>
        </Content>
    </Root>
);
